(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bonara-hero-difuminado"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bonara-fade-hero')) {
    class BonaraFadeHero extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.status = this.querySelector('[data-status]');
        this.pauseButton = this.querySelector('[data-pause]');
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.interval = Number(this.dataset.interval) || 5000;
        this.autoplay = this.dataset.autoplay === 'true';
        this.userPaused = false;
        this.interactionPaused = false;
        this.editorPaused = false;
        this.inViewport = true;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.index - 1, true), { signal });
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1, true), { signal });

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.show(Number(dot.dataset.dot), true), { signal });
        });

        this.pauseButton?.addEventListener('click', () => this.togglePause(), { signal });

        this.addEventListener('mouseenter', () => {
          this.interactionPaused = true;
          this.stopTimer();
        }, { signal });

        this.addEventListener('mouseleave', () => {
          this.interactionPaused = false;
          this.startTimer();
        }, { signal });

        this.addEventListener('focusin', () => {
          this.interactionPaused = true;
          this.stopTimer();
        }, { signal });

        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) {
            this.interactionPaused = false;
            this.startTimer();
          }
        }, { signal });

        this.addEventListener('touchstart', (event) => this.onTouchStart(event), { passive: true, signal });
        this.addEventListener('touchend', (event) => this.onTouchEnd(event), { passive: true, signal });

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stopTimer();
          else this.startTimer();
        }, { signal });

        document.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), { signal });
        document.addEventListener('shopify:block:deselect', (event) => this.onBlockDeselect(event), { signal });

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => {
            this.inViewport = entry.isIntersecting;
            if (this.inViewport) this.startTimer();
            else this.stopTimer();
          }, { threshold: 0.15 });
          this.observer.observe(this);
        }

        this.update(false);
        this.startTimer();
      }

      disconnectedCallback() {
        this.stopTimer();
        this.observer?.disconnect();
        this.abortController?.abort();
        this.initialized = false;
      }

      show(requestedIndex, restartAutoplay = false) {
        if (this.slides.length < 2) return;
        this.index = (requestedIndex + this.slides.length) % this.slides.length;
        this.update(restartAutoplay);

        if (restartAutoplay) {
          this.stopTimer();
          this.startTimer();
        }
      }

      update(announce = true) {
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
            element.tabIndex = active ? 0 : -1;
          });
        });

        this.dots.forEach((dot, index) => {
          const active = index === this.index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        if (announce && this.status) {
          this.status.textContent = `Diapositiva ${this.index + 1} de ${this.slides.length}`;
        }
      }

      startTimer() {
        this.stopTimer();
        if (
          !this.autoplay ||
          this.slides.length < 2 ||
          this.userPaused ||
          this.interactionPaused ||
          this.editorPaused ||
          this.reducedMotion ||
          document.hidden ||
          !this.inViewport
        ) return;

        this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
      }

      stopTimer() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }

      togglePause() {
        this.userPaused = !this.userPaused;
        this.pauseButton.setAttribute('aria-pressed', this.userPaused ? 'true' : 'false');
        this.pauseButton.setAttribute('aria-label', this.userPaused ? 'Reproducir diapositivas' : 'Pausar diapositivas');
        if (this.userPaused) this.stopTimer();
        else this.startTimer();
      }

      onTouchStart(event) {
        const touch = event.changedTouches[0];
        this.touchStartX = touch.clientX;
        this.touchStartY = touch.clientY;
      }

      onTouchEnd(event) {
        if (this.touchStartX == null || this.touchStartY == null) return;
        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - this.touchStartX;
        const deltaY = touch.clientY - this.touchStartY;
        this.touchStartX = null;
        this.touchStartY = null;

        if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        this.show(deltaX < 0 ? this.index + 1 : this.index - 1, true);
      }

      onBlockSelect(event) {
        if (String(event.detail?.sectionId) !== String(this.dataset.sectionId)) return;
        const slideIndex = this.slides.findIndex((slide) => slide.dataset.blockId === String(event.detail.blockId));
        if (slideIndex < 0) return;
        this.editorPaused = true;
        this.stopTimer();
        this.show(slideIndex);
      }

      onBlockDeselect(event) {
        if (String(event.detail?.sectionId) !== String(this.dataset.sectionId)) return;
        this.editorPaused = false;
        this.startTimer();
      }
    }

    customElements.define('bonara-fade-hero', BonaraFadeHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
